export default "__VITE_ASSET__240ee3c2__"